import { getterTree } from 'typed-vuex';
import initialState from './state';

export default getterTree(initialState, {
  isLogged: (state) => !!state.token,
});
